<template>
  <div>微信支付-结算表</div>
</template>

<script>
  export default {
    name: "set-accounts"
  }
</script>

<style scoped>

</style>
